import React, { useEffect, useState, useMemo } from "react";
import classnames from "classnames";
import {
  Card, CardBody, Col, Container, Row, Nav, NavItem, NavLink,
  Button, UncontrolledDropdown, DropdownToggle, DropdownMenu,
  DropdownItem, Spinner, UncontrolledTooltip, Badge
} from "reactstrap";

import TableContainer from "../../../components/Common/TableContainer";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { useNavigate } from "react-router-dom";

const Gezilerim = () => {
  document.title = "Gezilerim ";
  const navigate = useNavigate(); // <--- YÖNLENDİRME İÇİN EKLENDİ

  // ...
  const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
  const isAdmin = authUser?.HESAP_TURU === 'Admin';
  const isCustomer = authUser?.HESAP_TURU === 'Alıcı'; // <--- MÜŞTERİ KONTROLÜ EKLENDİ
  const userId = authUser?.ID;

  // 1. SEKME VE FİLTRE STATE'LERİ (Mobildeki gibi)
  const [activeTab, setActiveTab] = useState("1"); // 1: Aktif Görevler, 2: Geçmiş
  const [vehicleFilter, setVehicleFilter] = useState("ALL"); // ALL, TOWING, NORMAL
  const [dateFilter, setDateFilter] = useState(null); // NEW, OLD

  const [tripsData, setTripsData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  // 2. API'DEN VERİ ÇEKME
  useEffect(() => {
    const fetchMyTrips = async () => {
      setIsLoading(true);
      try {
        if (!userId) return;

        // Geçmişi (TESLIM_ETME) ve İlan Tipini anlayabilmek için Advert_DeliveryStatus ve Advert_Type'ı expand ediyoruz
  const filterStr = isAdmin 
            ? "$top=1000&$orderby=OLUSTURMA_TARIHI desc&" 
            : `$filter=KULLANICI_ID eq ${userId}&$top=1000&$orderby=OLUSTURMA_TARIHI desc&`;
            
        const expandStr = "$expand=KULLANICI_ARACLAR,ADRESLER,Advert_DeliveryStatus,Advert_Type";
                
        const response = await fetch(`https://harmanagelapi.stechomeyazilim.info/ILANLAR?${filterStr}${expandStr}`);
        const result = await response.json();

        if (result && result.value) {
          const formattedData = result.value.map(item => {
            const car = item.Users_Car || {};
            const location = item.ADRESLER?.[0] || {};
            const deliveryStatusArr = item.Advert_DeliveryStatus || [];
            
            // Teslim edilip edilmediğini kontrol et
            const isDelivered = deliveryStatusArr.some(s => s.Advert_DeliveryStatus_Status === "TESLIM_ETME");

            const sDate = item.Advert_DateTime ? new Date(item.Advert_DateTime) : null;
            const eDate = item.Advert_DateTime2 ? new Date(item.Advert_DateTime2) : null;

            return {
              id: item.ID,
              advertTypeId: item.Advert_Type_ID, // 1: Normal(Sürücü), 2: Çekici
              isDelivered: isDelivered, // Sekme filtrelemesi için
              rawDate: item.Advert_DateTime, // Sıralama için
              
              tags: item.Direction_Type || "", 
              status: isDelivered ? "Tamamlandı" : "Sıradaki İş",
              customer: item.Customer_Notes || "Müşteri Notu Yok",
              vehicleBody: car.Car_Body_Type || "-",
              vehiclePlate: car.PLAKA || "-",
              startCity: `${location.Start_City_Code || ''} ${location.ADRESLER_StartAddress?.split(',')[0] || ''}`,
              endCity: `${location.Finish_City_Code || ''} ${location.ADRESLER_FinishAddress?.split(',')[0] || ''}`,
              startDate: sDate ? `${sDate.toLocaleDateString('tr-TR')} ${sDate.getHours().toString().padStart(2, '0')}:${sDate.getMinutes().toString().padStart(2, '0')}` : "-",
              endDate: eDate ? `${eDate.toLocaleDateString('tr-TR')} ${eDate.getHours().toString().padStart(2, '0')}:${eDate.getMinutes().toString().padStart(2, '0')}` : "-",
              distance: location.Km ? `${location.Km} km` : "-",
              price: item.Price || 0,
              
              // Harita için tam adresler
              fullStart: location.ADRESLER_StartAddress || "",
              fullEnd: location.ADRESLER_FinishAddress || ""
            };
          });
          setTripsData(formattedData);
        }
      } catch (error) {
        console.error("Gezilerim verisi çekilirken hata:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchMyTrips();
  }, [isAdmin, userId]);

  // 3. SEKMELERE VE FİLTRELERE GÖRE VERİYİ SÜZME (Mobildeki gibi)
  const filteredTrips = useMemo(() => {
    let result = tripsData;

    // A. Sekme Filtresi (Aktif / Geçmiş)
    if (activeTab === "1") {
      result = result.filter(trip => !trip.isDelivered); // Aktif (Teslim edilmemiş)
    } else {
      result = result.filter(trip => trip.isDelivered);  // Geçmiş (Teslim edilmiş)
    }

    // B. Araç Tipi Filtresi
    if (vehicleFilter === "TOWING") result = result.filter(trip => trip.advertTypeId === 2);
    if (vehicleFilter === "NORMAL") result = result.filter(trip => trip.advertTypeId === 1);

    // C. Tarih Sıralaması
    if (dateFilter) {
      result = [...result].sort((a, b) => {
        const dateA = new Date(a.rawDate || 0).getTime();
        const dateB = new Date(b.rawDate || 0).getTime();
        return dateFilter === "NEW" ? dateB - dateA : dateA - dateB;
      });
    }

    return result;
  }, [tripsData, activeTab, vehicleFilter, dateFilter]);

  // Filtre Sıfırlama
  const resetFilters = () => {
    setVehicleFilter("ALL");
    setDateFilter(null);
  };

  // 4. TABLO KOLONLARI
  const columns = useMemo(
    () => [
      {
        header: "Görev No",
        accessorKey: "id",
        enableSorting: true,
        cell: (cellProps) => <span className="fw-bold">#{cellProps.row.original.id}</span>
      },
      {
        header: "Durum / Tip",
        accessorKey: "status",
        enableSorting: true,
        cell: (cellProps) => {
          const row = cellProps.row.original;
          return (
            <div>
              <Badge color={row.isDelivered ? "success" : "warning"} className="mb-1">
                {row.status}
              </Badge><br/>
              <span className="text-muted" style={{fontSize: "11px"}}>
                {row.advertTypeId === 2 ? "Çekici" : "Sürücü"}
              </span>
            </div>
          );
        }
      },
      {
        header: "Güzergah",
        accessorKey: "startCity",
        cell: (cellProps) => {
          const row = cellProps.row.original;
          return (
              <div style={{ fontSize: '12px' }}>
                  <span className="text-success fw-bold">{row.startCity}</span> <br/>
                  <i className="mdi mdi-arrow-down text-muted"></i> <br/>
                  <span className="text-danger fw-bold">{row.endCity}</span>
              </div>
          );
        }
      },
      {
        header: "Müşteri / Araç",
        accessorKey: "customer",
        cell: (cellProps) => {
          const row = cellProps.row.original;
          return (
            <div style={{ maxWidth: "150px" }}>
              <div className="text-truncate fw-bold mb-1" title={row.customer}>{row.customer}</div>
              <div className="text-muted" style={{ fontSize: '12px' }}>
                {row.vehicleBody} • {row.vehiclePlate}
              </div>
            </div>
          );
        }
      },
      {
        header: "Zaman Planı",
        accessorKey: "startDate",
        cell: (cellProps) => {
          const row = cellProps.row.original;
          return (
            <div style={{ fontSize: '11px', whiteSpace: 'nowrap' }}>
              <div><strong className="text-success">Bşl:</strong> {row.startDate}</div>
              <div><strong className="text-danger">Bit:</strong> {row.endDate}</div>
            </div>
          );
        }
      },
      {
        header: "Mesafe & Ücret",
        accessorKey: "price",
        cell: (cellProps) => {
          const row = cellProps.row.original;
          return (
            <div>
              <div className="fw-bold">{row.price} TL</div>
              <div className="text-muted" style={{fontSize: "11px"}}><i className="mdi mdi-road-variant"></i> {row.distance}</div>
            </div>
          );
        }
      },
    {
        header: "Eylemler",
        enableSorting: false,
        cell: (cellProps) => {
          const row = cellProps.row.original;
          
          const gmapsUrl = `https://www.google.com/maps/dir/?api=1&origin=${encodeURIComponent(row.fullStart)}&destination=${encodeURIComponent(row.fullEnd)}`;

          const handleCancelAdvert = async () => {
             if(window.confirm("Bu talebi iptal etmek istediğinize emin misiniz?")) {
                 try {
                     await fetch(`https://harmanagelapi.stechomeyazilim.info/ILANLAR(${row.id})`, {
                         method: "PATCH",
                         headers: { "Content-Type": "application/json" },
                         body: JSON.stringify({ Is_Active: false })
                     });
                     alert("İlan başarıyla iptal edildi.");
                     window.location.reload(); // Sayfayı yenile
                 } catch (error) {
                     alert("İptal edilirken bir hata oluştu.");
                 }
             }
          };

          return (
            <div className="d-flex align-items-center gap-1">
              <UncontrolledDropdown>
                <DropdownToggle className="btn btn-light btn-sm border-secondary text-dark d-flex align-items-center">
                  <span className="fw-bold me-1">Aksiyon</span> 
                  <i className="mdi mdi-menu-down"></i>
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem href={gmapsUrl} target="_blank">
                    <i className="mdi mdi-google-maps text-success me-2"></i> Rotayı Haritada Aç
                  </DropdownItem>
                  <DropdownItem tag="a" href={`/job-details/${row.id}`}>
                    <i className="mdi mdi-eye text-primary me-2"></i> {isCustomer ? "Talep Detayı" : "Görev Detayı"}
                  </DropdownItem>
                  
                  {/* SADECE MÜŞTERİ (VEYA ADMİN) KENDİ İLANLARINI OYNAYABİLİR (Teslim edilmemişse) */}
                  {(isCustomer || isAdmin) && !row.isDelivered && (
                    <>
                      <DropdownItem divider />
                      <DropdownItem onClick={() => navigate(`/talep-duzenle/${row.id}`)}>
                        <i className="mdi mdi-pencil text-warning me-2"></i> Düzenle
                      </DropdownItem>
                      <DropdownItem onClick={handleCancelAdvert}>
                        <i className="mdi mdi-trash-can-outline text-danger me-2"></i> İptal Et
                      </DropdownItem>
                    </>
                  )}
                </DropdownMenu>
              </UncontrolledDropdown>
            </div>
          );
        }
      },
    ],
    []
  );

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="HarmanaGEL" breadcrumbItem="Görevlerim" />
          
        <div className="d-flex justify-content-between align-items-center mb-4">
              <h2>
                  {isAdmin ? "Sistemdeki Tüm Görevler" : (isCustomer ? "Taleplerim" : "Görevlerim")}
              </h2>
              
              <div className="d-flex gap-2">
                  <Button color="light" size="sm" className="text-primary border-primary bg-transparent fw-medium d-flex align-items-center">
                      <i className="mdi mdi-help-circle-outline me-1"></i> 
                      {isCustomer ? "Taleplerimi" : "Görevlerimi"} nasıl takip ederim?
                  </Button>

                  {/* SADECE MÜŞTERİ VEYA ADMİN İÇİN YENİ TALEP BUTONU */}
                  {(isCustomer || isAdmin) && (
                      <Button color="primary" size="sm" className="fw-bold d-flex align-items-center shadow-sm" onClick={() => navigate("/ecommerce-add-product")}>
                          <i className="mdi mdi-plus-circle-outline fs-5 me-1"></i> 
                          Yeni Talep Oluştur
                      </Button>
                  )}
              </div>
          </div>

          <Row>
            <Col lg="12">
              <Card>
                {/* 1. SEKMELER (Aktif / Geçmiş) */}
                <CardBody className="pt-0 pb-0 border-bottom">
                  <Nav tabs className="nav-tabs-custom">
                    <NavItem>
                      <NavLink className={classnames({ active: activeTab === "1" }, "fw-medium")} onClick={() => toggleTab("1")} style={{ cursor: 'pointer' }}>
                        <i className="mdi mdi-clock-outline me-1"></i> Aktif Görevler
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink className={classnames({ active: activeTab === "2" }, "fw-medium")} onClick={() => toggleTab("2")} style={{ cursor: 'pointer' }}>
                        <i className="mdi mdi-check-circle-outline me-1"></i> Geçmiş (Tamamlananlar)
                      </NavLink>
                    </NavItem>
                  </Nav>
                </CardBody>
                
                <CardBody>
                  {/* 2. FİLTRELER (Hizmet Türü ve Tarih Sıralaması) */}
                  <div className="d-flex align-items-center flex-wrap gap-3 mb-4">
                    <div className="btn-group" role="group">
                      <Button color={vehicleFilter === "ALL" ? "primary" : "light"} onClick={() => setVehicleFilter("ALL")} size="sm">Tümü</Button>
                      <Button color={vehicleFilter === "TOWING" ? "primary" : "light"} onClick={() => setVehicleFilter("TOWING")} size="sm">Çekici</Button>
                      <Button color={vehicleFilter === "NORMAL" ? "primary" : "light"} onClick={() => setVehicleFilter("NORMAL")} size="sm">Sürücü</Button>
                    </div>

                    <div className="btn-group" role="group">
                      <Button color={dateFilter === "NEW" ? "info" : "light"} onClick={() => setDateFilter(dateFilter === "NEW" ? null : "NEW")} size="sm">
                        <i className="mdi mdi-arrow-up"></i> En Yeni
                      </Button>
                      <Button color={dateFilter === "OLD" ? "info" : "light"} onClick={() => setDateFilter(dateFilter === "OLD" ? null : "OLD")} size="sm">
                        <i className="mdi mdi-arrow-down"></i> En Eski
                      </Button>
                    </div>

                    {(vehicleFilter !== "ALL" || dateFilter !== null) && (
                      <Button color="danger" outline size="sm" onClick={resetFilters}>
                         <i className="mdi mdi-close"></i> Filtreleri Temizle
                      </Button>
                    )}
                  </div>

                  {/* 3. VERİ TABLOSU */}
                  {isLoading ? (
                    <div className="text-center py-5">
                      <Spinner color="primary" /> <p className="mt-2 text-muted">Görevleriniz yükleniyor...</p>
                    </div>
                  ) : filteredTrips.length > 0 ? (
                    <TableContainer
                      columns={columns}
                      data={filteredTrips}
                      isGlobalFilter={true} 
                      SearchPlaceholder="Görev No, Müşteri veya Konum Ara..."
                      isCustomPageSize={true}
                      isPagination={true}
                      tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-hover"
                      theadClass="table-light"
                      paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                    />
                  ) : (
                    <div className="text-center text-muted py-5">
                        <i className="mdi mdi-inbox-outline display-4"></i>
                        <h5>Görev Bulunmuyor</h5>
                        <p>Şu an listelenecek bir veri yok.</p>
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Gezilerim;